import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";
import { isBefore } from "date-fns";

import { Payload } from "@neworbit/redux-helpers";

import { isCancel } from "axios";

import { ApplicationState } from "../../applicationState";

import * as actions from "./actiontypes";
import * as models from "./model";
import { customerCategoryApi } from "./customerCategoryApi";

import { push } from "redux-little-router";

export type CustomerCategoryAction =
    ({ type: typeof actions.LOAD_CUSTOMERCATEGORIES_SUCCESS } & Payload<models.CustomerCategoryListModel[]>)
    | ({ type: typeof actions.CREATE_CUSTOMERCATEGORY_SUCCESS } & Payload<models.CustomerCategoryDetailModel>)
    | ({ type: typeof actions.LOAD_CUSTOMERCATEGORY_DETAIL_SUCCESS } & Payload<models.CustomerCategoryDetailModel>)
    | ({ type: typeof actions.SAVE_CUSTOMERCATEGORY_SUCCESS } & Payload<models.CustomerCategoryDetailModel>)
    | ({ type: typeof actions.DELETE_CUSTOMERCATEGORY_SUCCESS } & Payload<string>);

export const loadCustomerCategoriesSuccess = (payload: models.CustomerCategoryListModel[]): CustomerCategoryAction => ({
    payload,
    type: actions.LOAD_CUSTOMERCATEGORIES_SUCCESS
});

export const createCustomerCategorySuccess = (payload: models.CustomerCategoryDetailModel): CustomerCategoryAction => ({
    payload,
    type: actions.CREATE_CUSTOMERCATEGORY_SUCCESS
});

export const saveCustomerCategorySuccess = (payload: models.CustomerCategoryDetailModel): CustomerCategoryAction => ({
    payload,
    type: actions.SAVE_CUSTOMERCATEGORY_SUCCESS
});

export const deleteCustomerCategorySuccess = (payload: string): CustomerCategoryAction => ({
    payload,
    type: actions.DELETE_CUSTOMERCATEGORY_SUCCESS
});

export function createCustomerCategory(customerCategory: models.CustomerCategoryFormModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CUSTOMERCATEGORY, customerCategoryApi.create(customerCategory));
        dispatch(createCustomerCategorySuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveCustomerCategory(customerCategory: models.CustomerCategoryFormModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_CUSTOMERCATEGORY, customerCategoryApi.save(customerCategory));

        dispatch(saveCustomerCategorySuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function loadCustomerCategories() {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, "loadCustomerCategories", customerCategoryApi.getAll());
            dispatch(loadCustomerCategoriesSuccess(result));
        } catch (ex) {
            if (!(isCancel(ex))) {
                throw ex;
            }
        }
    };
}

export const loadCustomerCategoryDetailSuccess = (customerCategory: models.CustomerCategoryDetailModel) => ({
    payload: customerCategory,
    type: actions.LOAD_CUSTOMERCATEGORY_DETAIL_SUCCESS
});

export function loadCustomerCategoryDetail({ customerCategoryId }: { customerCategoryId: string }) {
    return async (dispatch: Dispatch, getState: () => ApplicationState) => {
        const customerCategory = getState().customerCategories.filter(c => c.id === customerCategoryId)[0];

        if (customerCategory === undefined
            || customerCategory.detailUpdated === undefined
            || isBefore(customerCategory.listUpdated, customerCategory.detailUpdated)) {

            const action = customerCategory === undefined ? createCustomerCategorySuccess : loadCustomerCategoryDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadCustomerCategoryDetail", customerCategoryApi.detail(customerCategoryId));
            dispatch(action(result));
        }
    };
}

export function deleteCustomerCategory(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, "deleteCustomerCategory", customerCategoryApi.delete(id));
        dispatch(deleteCustomerCategorySuccess(id));
        dispatch(push(path, {}));
    };
}
